// extracted by mini-css-extract-plugin
export default {"container":"Content_container__eUbiC","image":"Content_image__Ci5Gi"};